import type {KeyBinding} from '@codemirror/view'

import {formatBlockquote} from '../commands/blockquotes/format-blockquote'
import {splitBlockquoteIfBlankLine} from '../commands/blockquotes/split-blockquote-if-blank'
import {formatHeading} from '../commands/headings/format-heading'
import {indentLineIfCodeBlock, unindentLineIfCodeBlock} from '../commands/indent-if-code-block'
import {WRAP_DELIMITER_MAP, type WrappableDelimiter} from '../commands/inline-formatting/constants'
import {
  formatBold,
  formatInlineCode,
  formatItalic,
  formatStrikethrough,
} from '../commands/inline-formatting/format-inline'
import {formatLink} from '../commands/inline-formatting/format-link'
import {wrapWithDelimiter} from '../commands/inline-formatting/wrap-with-delimiter'
import {dedentListIfBlankItem} from '../commands/lists/dedent-if-blank'
import {dedentSelectedListItems} from '../commands/lists/dedent-selected-items'
import {formatOrderedList, formatUnorderedList} from '../commands/lists/format-list'
import {indentSelectedListItems} from '../commands/lists/indent-selected-items'
import {insertNewListItem} from '../commands/lists/insert-new-item'
import {visitIfLink} from '../commands/visit-if-link'

export const formatLinkKeybinding: KeyBinding = {
  key: 'Mod-Shift-u',
  run: formatLink,
}

export const formatBoldKeybinding: KeyBinding = {
  key: 'Mod-b',
  run: formatBold,
}

export const formatItalicKeybinding: KeyBinding = {
  key: 'Mod-i',
  run: formatItalic,
}

export const formatInlineCodeKeybinding: KeyBinding = {
  key: 'Mod-e',
  run: formatInlineCode,
}

export const formatBlockquoteKeybinding: KeyBinding = {
  key: 'Mod-Shift-.',
  run: formatBlockquote,
}

export const formatUnorderedListKeybinding: KeyBinding = {
  key: 'Mod-8',
  run: formatUnorderedList,
}

export const formatOrderedListKeybinding: KeyBinding = {
  key: 'Mod-7',
  run: formatOrderedList,
}

export const formatHeading1Keybinding: KeyBinding = {key: 'Mod-Alt-1', run: view => formatHeading(view, 1)}
export const formatHeading2Keybinding: KeyBinding = {key: 'Mod-Alt-2', run: view => formatHeading(view, 2)}
export const formatHeading3Keybinding: KeyBinding = {key: 'Mod-Alt-3', run: view => formatHeading(view, 3)}
export const formatHeading4Keybinding: KeyBinding = {key: 'Mod-Alt-4', run: view => formatHeading(view, 4)}
export const formatHeading5Keybinding: KeyBinding = {key: 'Mod-Alt-5', run: view => formatHeading(view, 5)}
export const formatHeading6Keybinding: KeyBinding = {key: 'Mod-Alt-6', run: view => formatHeading(view, 6)}

export const formatStrikethroughKeybinding: KeyBinding = {
  key: 'Mod-Shift-x',
  run: formatStrikethrough,
}

const wrapWithDelimiterKeybindings: KeyBinding[] = Object.keys(WRAP_DELIMITER_MAP).map(key => ({
  key,
  run: wrapWithDelimiter(key as WrappableDelimiter),
}))

export const markdownKeymap: KeyBinding[] = [
  {
    key: 'Enter',
    run: dedentListIfBlankItem,
  },
  {
    key: 'Enter',
    run: insertNewListItem,
  },
  {
    key: 'Enter',
    run: splitBlockquoteIfBlankLine,
  },
  {key: 'Alt-Enter', run: visitIfLink},
  formatLinkKeybinding,
  formatBoldKeybinding,
  formatItalicKeybinding,
  formatInlineCodeKeybinding,
  formatStrikethroughKeybinding,
  formatBlockquoteKeybinding,
  formatUnorderedListKeybinding,
  formatOrderedListKeybinding,
  formatHeading1Keybinding,
  formatHeading2Keybinding,
  formatHeading3Keybinding,
  formatHeading4Keybinding,
  formatHeading5Keybinding,
  formatHeading6Keybinding,
  ...wrapWithDelimiterKeybindings,
  {
    key: 'Tab',
    run: indentLineIfCodeBlock,
  },
  {
    key: 'Shift-Tab',
    run: unindentLineIfCodeBlock,
  },
  {
    key: 'Shift-Tab',
    run: dedentSelectedListItems,
  },
  {
    key: 'Tab',
    run: indentSelectedListItems,
  },
  {
    key: 'Mod-[',
    run: dedentSelectedListItems,
  },
  {
    key: 'Mod-]',
    run: indentSelectedListItems,
  },
]
